import type { ReactNode } from "react";
import { cx } from "../utils/cx";
import styles from "./Badge.module.css";

export type BadgeVariant =
  | "neutral"
  | "success"
  | "warning"
  | "error"
  | "info"
  | "accent";

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
}

/**
 * A compact status/count label (style-guide.md: Badges). For short content
 * only — one or two words, a version, or a count.
 */
function Badge({ variant = "neutral", children }: BadgeProps) {
  return <span className={cx(styles.badge, styles[variant])}>{children}</span>;
}

export default Badge;
